import { Field, Switch } from '@headlessui/react';
import { cn } from '../../../utilities/cn';

export interface RSwitchProps {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
  className?: string;
  trackClassName?: string;
  wrapperClassName?: string;
  label?: string;
  labelOn?: string;
}

const sideLabelClass = (active: boolean) =>
  cn(
    'text-sm transition-colors',
    active
      ? 'font-semibold text-mainblue'
      : 'font-medium text-gray-400 hover:text-gray-600',
  );

export default function RSwitch({
  enabled,
  setEnabled,
  className,
  trackClassName,
  wrapperClassName,
  label,
  labelOn,
}: RSwitchProps) {
  return (
    <Field>
      <div className={cn('my-2 flex items-center gap-2', wrapperClassName)}>
        {label && (
          <button
            type="button"
            onClick={() => setEnabled(false)}
            className={sideLabelClass(!enabled)}
          >
            {label}
          </button>
        )}
        <Switch
          checked={enabled}
          onChange={setEnabled}
          className={cn(
            'group relative flex h-5 w-9 cursor-pointer rounded-full bg-gray-300 p-0.5 transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-mainblue data-[focus]:outline-1 data-[focus]:outline-mainblue',
            className,
          )}
        >
          <span
            aria-hidden="true"
            className={cn(
              'pointer-events-none inline-block size-4 translate-x-0 rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-4',
              trackClassName,
            )}
          />
        </Switch>
        {labelOn && (
          <button
            type="button"
            onClick={() => setEnabled(true)}
            className={sideLabelClass(enabled)}
          >
            {labelOn}
          </button>
        )}
      </div>
    </Field>
  );
}
